/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr, IPcrs } from '../../pcr/store/pcr.types'
import { getServiceIdSelector, getUserIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../selectors'
import { applyFilter, setPcrList } from '../store/home.actions'
import Logger from '../../../services/logger.service'
import { HomeConstants } from '../store/home.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* lockPCR() {
  const serviceId: string = yield select(getServiceIdSelector)
  const userId: string = yield select(getUserIdSelector)
  const pcrId: string = yield select(getPcrIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
  try {
    pcrDoc.isChartLockedIn = 1
    Logger.info(`PCR: ${pcrId} Locked In by user: ${userId} in service: ${serviceId}`)
    const pcrDocs: IPcrs = yield call([pcrDocsService, pcrDocsService.getPCRDocsPerUser], userId)
    yield put(
      setPcrList(
        pcrDocs.map((doc: IPcr) => {
          if (doc.prid === pcrId) {
            const newPcr = { ...doc }
            newPcr.isChartLockedIn = 1
            return newPcr
          }
          return doc
        })
      )
    )
    yield put(applyFilter())
  } catch (e) {
    yield put(throwPcrException(`lockPCR() error: ${e}`))
  }
}

export function* lockPCRSaga() {
  yield takeLatest([HomeConstants.SET_IS_CHART_LOCKED_IN], performWithMutexHOG, lockPCR)
}
